import { TYPES } from 'action-types/booking';
import * as validateMessage from 'constants/validationMessages';
import {
    IEquipmentDetailsForExportJob,
    IExportDetailsForCostItem,
    IExportDetailsForRevenueItem,
} from 'reducers/exportJob/models';
import { ICostAndRevenues, ICostAndRevenuesNew } from './models';
interface IAction {
    readonly payload: any;
    readonly type: string;
    readonly response: ICostAndRevenues;
    readonly revenueResponse: ICostAndRevenuesNew;
    readonly costResponse: ICostAndRevenuesNew;
    readonly errors: any[];
    readonly newCode: any;
    readonly delete: any;
    readonly update: string;
    readonly exportJobsChargeRev: IExportDetailsForRevenueItem;
    readonly exportJobsChargeCost: IExportDetailsForCostItem;
    readonly equipmentsForExportJob: IEquipmentDetailsForExportJob;
}
export interface ICostRevenueState {
    readonly isFetchDataLoading: boolean;
    readonly isFetchDataError: boolean;
    readonly pendingError: string;
    readonly response: any;
    readonly costRevEditSuccess: boolean;
    readonly newCode: any;
    readonly delete: any;
    readonly update: string;
    readonly revenueResponse: any;
    readonly costResponse: any;
    readonly exportJobsChargeRev: any;
    readonly exportJobsChargeCost: any;
    readonly equipmentsForExportJob: any;
    readonly pendingProcessingMessages: {
        type: string;
        messages: string[];
    };
}

export const defaultState: ICostRevenueState = {
    costRevEditSuccess: false,
    isFetchDataLoading: false,
    isFetchDataError: false,
    pendingError: '',
    update: '',
    newCode: {},
    response: {
        page: 1,
        pageSize: 0,
        totalCount: 0,
        result: [],
    },
    revenueResponse: {
        page: 1,
        pageSize: 0,
        totalCount: 0,
        data: [],
    },
    costResponse: {
        page: 1,
        pageSize: 0,
        totalCount: 0,
        data: [],
    },
    delete: {},
    exportJobsChargeRev: {
        page: 1,
        pageSize: 0,
        totalCount: 0,
        data: [],
    },
    exportJobsChargeCost: {
        page: 1,
        pageSize: 0,
        totalCount: 0,
        data: [],
    },
    equipmentsForExportJob: {
        page: 1,
        pageSize: 0,
        totalCount: 0,
        data: [],
    },
    pendingProcessingMessages: {
        type: '',
        messages: [],
    }
};

const check = (error: any) => {
    if (
        (error && !Array.isArray(error)) ||
        (error && Array.isArray(error) && error.length > 0)
    ) {
        return error;
    }
    return '';
};
export const reducer = (
    state: ICostRevenueState = defaultState,
    action: IAction,
): ICostRevenueState => {
    switch (action.type) {
        case TYPES.FETCH_COST_REVENUE.PENDING:
            return {
                ...state,
                isFetchDataLoading: true,
                isFetchDataError: false,
                newCode: null,
                pendingError: '',
                update: '',
                response: defaultState.response,
            };
        case TYPES.FETCH_COST_REVENUE.FULFILLED:
            const response = action.response;

            const normalizeBlockedType = (type: string) => {
                switch (type) {
                    case 'UNBLOCK':
                        return '';
                    case 'AMENDMENT':
                        return 'AMENDMENT - ICP';
                    case 'INVOICE':
                        return 'INVOICE - ICP';
                    default:
                        return type;
                }
            };

            const mapped = response.result.map((item: any) => ({
                ...item,
                essoRateDetailsModels: item.essoRateDetailsModels?.map((e: any) => ({
                    ...e,
                    blockedType: normalizeBlockedType(e.blockedType),
                })),
                issoChargeLines: item.issoChargeLines?.map((e: any) => ({
                    ...e,
                    blockedType: normalizeBlockedType(e.blockedType),
                })),
            }));

            return {
                ...state,
                response: {
                    ...response,
                    result: mapped,
                },
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: '',
            };
        case TYPES.FETCH_COST_REVENUE.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: check(action.errors)
                    ? action.errors.toString()
                    : validateMessage.CostAndRevenue
                        .Error_Retrieve_charges,
            };

        case TYPES.FETCH_EXPORTJOBS_CHARGE_REV.PENDING:
            return {
                ...state,
                isFetchDataLoading: true,
                isFetchDataError: false,
                newCode: null,
                pendingError: '',
                update: '',
                exportJobsChargeRev:
                    defaultState.exportJobsChargeRev,
            };
        case TYPES.FETCH_EXPORTJOBS_CHARGE_REV.FULFILLED:
            return {
                ...state,
                exportJobsChargeRev: action.exportJobsChargeRev,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: '',
            };
        case TYPES.FETCH_EXPORTJOBS_CHARGE_REV.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: check(action.errors)
                    ? action.errors.toString()
                    : validateMessage.CostAndRevenue
                        .Error_Retrieve_charges,
            };

        case TYPES.FETCH_EXPORTJOBS_CHARGE_COST.PENDING:
            return {
                ...state,
                isFetchDataLoading: true,
                isFetchDataError: false,
                newCode: null,
                pendingError: '',
                update: '',
                exportJobsChargeCost:
                    defaultState.exportJobsChargeCost,
            };
        case TYPES.FETCH_EXPORTJOBS_CHARGE_COST.FULFILLED:
            return {
                ...state,
                exportJobsChargeCost:
                    action.exportJobsChargeCost,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: '',
            };
        case TYPES.FETCH_EXPORTJOBS_CHARGE_COST.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: check(action.errors)
                    ? action.errors.toString()
                    : validateMessage.CostAndRevenue
                        .Error_Retrieve_charges,
            };

        case TYPES.FETCH_EQUIPMENTS_EXPORTJOB.PENDING:
            return {
                ...state,
                isFetchDataLoading: true,
                isFetchDataError: false,
                newCode: null,
                pendingError: '',
                update: '',
                equipmentsForExportJob:
                    defaultState.equipmentsForExportJob,
            };
        case TYPES.FETCH_EQUIPMENTS_EXPORTJOB.FULFILLED:
            return {
                ...state,
                equipmentsForExportJob:
                    action.equipmentsForExportJob,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: '',
            };
        case TYPES.FETCH_EQUIPMENTS_EXPORTJOB.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: check(action.errors)
                    ? action.errors.toString()
                    : validateMessage.CostAndRevenue
                        .Error_Retrieve_charges,
            };

        case TYPES.FETCH_REVENUE_DATA.PENDING:
            return {
                ...state,
                isFetchDataLoading: true,
                isFetchDataError: false,
                newCode: null,
                pendingError: '',
                update: '',
                revenueResponse: defaultState.revenueResponse,
            };
        case TYPES.FETCH_REVENUE_DATA.FULFILLED:
            return {
                ...state,
                revenueResponse: action.revenueResponse,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: '',
            };
        case TYPES.FETCH_REVENUE_DATA.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: check(action.errors)
                    ? action.errors.toString()
                    : validateMessage.CostAndRevenue
                        .Error_Retrieve_charges,
            };

        case TYPES.FETCH_COST_DATA.PENDING:
            return {
                ...state,
                isFetchDataLoading: true,
                isFetchDataError: false,
                newCode: null,
                pendingError: '',
                update: '',
                costResponse: defaultState.costResponse,
            };
        case TYPES.FETCH_COST_DATA.FULFILLED:
            return {
                ...state,
                costResponse: action.costResponse,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: '',
            };
        case TYPES.FETCH_COST_DATA.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: check(action.errors)
                    ? action.errors.toString()
                    : validateMessage.CostAndRevenue
                        .Error_Retrieve_charges,
            };

        case TYPES.ADD_COST_REVENUE.PENDING:
            return {
                ...state,
                costRevEditSuccess: false,
                isFetchDataLoading: true,
                isFetchDataError: false,
                pendingError: '',
            };
        case TYPES.ADD_COST_REVENUE.FULFILLED:
            return {
                ...state,
                costRevEditSuccess: true,
                newCode: action.newCode,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: '',
            };
        case TYPES.ADD_COST_REVENUE.REJECTED:
            return {
                ...state,
                costRevEditSuccess: false,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: check(action.errors)
                    ? action.errors.toString()
                    : validateMessage.CostAndRevenue
                        .Error_Add_charges,
            };
        case TYPES.ADD_COST_REVENUE.RESET_ERROR:
            return {
                ...state,
                costRevEditSuccess: false,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: '',
            };
        case TYPES.EDIT_COST_REVENUE.PENDING:
            return {
                ...state,
                isFetchDataLoading: true,
                isFetchDataError: false,
                pendingError: '',
            };
        case TYPES.EDIT_COST_REVENUE.FULFILLED:
            return {
                ...state,
                delete: action.response,
                isFetchDataLoading: false,
                isFetchDataError: false,
                pendingError: '',
            };
        case TYPES.EDIT_COST_REVENUE.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                pendingError: check(action.errors)
                    ? action.errors.toString()
                    : validateMessage.CostAndRevenue
                        .Error_Edit_charges,
            };

        case TYPES.UPDATE_CHARGES.PENDING:
        case TYPES.REFRESH_ATHENA_RATES.PENDING:
            return {
                ...state,
                isFetchDataLoading: true,
                isFetchDataError: false,
                update: '',
            };
        case TYPES.UPDATE_CHARGES.FULFILLED:
        case TYPES.REFRESH_ATHENA_RATES.FULFILLED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: false,
                update: action.update
                    ? `${action.update.replace(
                        /[.*+\-?^${}()|[\]\\]/g,
                        '',
                    )}. Please note this operation requires a page refresh in a few seconds`
                    : 'Update sucessfull',
            };
        case TYPES.UPDATE_CHARGES.REJECTED:
        case TYPES.REFRESH_ATHENA_RATES.REJECTED:
            return {
                ...state,
                isFetchDataLoading: false,
                isFetchDataError: true,
                update:
                    action.errors &&
                        action.errors.length > 0
                        ? action.errors.toString()
                        : 'An error has occured during the update',
            };

        case TYPES.FETCH_PENDING_PROCESSING_MESSAGES.PENDING:
            return {
                ...state,
                pendingProcessingMessages: {
                    type: '',
                    messages: [],
                },
            };
        case TYPES.FETCH_PENDING_PROCESSING_MESSAGES.FULFILLED:
            return {
                ...state,
                pendingProcessingMessages: {
                    type: action.payload.type,
                    messages: action.payload.messages,
                },
            };
        case TYPES.FETCH_PENDING_PROCESSING_MESSAGES.REJECTED:
            return {
                ...state,
                pendingProcessingMessages: {
                    type: action.payload.type,
                    messages: [],
                },
            };

        default:
            return state;
    }
};
